import React from 'react';

export default function Spinner({ text = 'Se încarcă...' }) {
  return (
    <div style={{display:'flex',alignItems:'center',justifyContent:'center',padding:40,gap:12,color:'#888'}}>
      <div style={{
        width:24, height:24, border:'3px solid #e0e8f0',
        borderTop:'3px solid #1a3a5c', borderRadius:'50%',
        animation:'spin 0.8s linear infinite'
      }}/>
      <span style={{fontSize:13}}>{text}</span>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
